/* eslint-disable */
import {createStore} from 'vuex'
import geral from './modules/geral'
import token from "./modules/token";
import contas from "./modules/contas";
import caixas from "./modules/caixas";
import usuarios from './modules/usuarios'
import empresas from "./modules/empresas";
import relatorio from "./modules/relatorio";
import auditoria from "./modules/auditoria";
import configDash from "./modules/configDash";
import contas_pagar from "./modules/contas_pagar";
import fornecedores from "./modules/fornecedores";
import centro_custos from "./modules/centro_custos";
import grupos_acessos from "./modules/grupos_acessos";
import eventos_caixas from "./modules/eventos_caixas";
import previsoes_caixa from "./modules/previsoes_caixa";
import centro_ativos_recursos from "./modules/centro_ativos_recursos";
import formas_pagamento from "./modules/formas_pagamento";

export default createStore({
   modules: {
      geral,
      token,
      caixas,
      contas,
      empresas,
      usuarios,
      relatorio,
      auditoria,
      configDash,
      contas_pagar,
      fornecedores,
      centro_custos,
      grupos_acessos,
      eventos_caixas,
      previsoes_caixa,
      formas_pagamento,
      centro_ativos_recursos
   }
})
